import { createApp } from 'vue';
// vue-dompurify-html (XSS 방지)
import VueDOMPurifyHTML from 'vue-dompurify-html';
// directive
import CKEditor from '@ckeditor/ckeditor5-vue';
// vue-query
import { VueQueryPlugin, VueQueryPluginOptions } from '@tanstack/vue-query';

import InputPassword from '@/components/atom/input/InputPassword.vue';
import InputSearch from '@/components/atom/input/InputSearch.vue';
// component
import InputText from '@/components/atom/input/InputText.vue';
import Pagination from '@/components/layout/common/Pagination.vue';
import router from '@/router';
import stores from '@/stores';

import 'swiper/css/bundle'; // 스와이퍼 css

import SkeletonLoading from './components/loading/SkeletonLoading.vue';
import App from './App.vue';

// style
import '@/assets/css/reset.css';
import '@/assets/css/common.scss';
import '@/assets/css/editor.scss';
import '@splidejs/vue-splide/css'; // 스플라이드 css
import 'vue-fullpage.js/dist/style.css';
import '@/assets/css/components/button.css';
import '@/assets/css/components/input.css';
import '@/assets/css/components/mypage.css';
import '@/assets/css/components/more.css';

if (import.meta.env.PROD) {
	console.log = () => {};
	console.error = () => {};
	console.debug = () => {};
}

declare global {
	interface Window {
		webkit: any;
		masterpick: any;
	}
}

// vue-query 기본 옵션 설정
const vueQueryPluginOptions: VueQueryPluginOptions = {
	queryClientConfig: {
		defaultOptions: {
			queries: {
				refetchOnWindowFocus: true, // 달콘은 모바일 환경. background에서 foreground로 올라올때 필요
				retry: false,
				// retryDelay: (attemptIdx) => Math.min(1000 * 3 ** attemptIdx, 30000),
			},
		},
	},
};

const vuePurifyHTMLConfig = {
	ADD_TAGS: ['iframe'],
	ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'style', 'allowfullscreen', 'allow', 'frameborder', 'title'], // 허용할 속성 추가
};

const app = createApp(App);
// global variable
app.provide('MAX_EXPOSURE', '500');
app.provide('MAX_EXPOSURE_JPN', '200');
// component - input
app.component('InputText', InputText);
app.component('InputSearch', InputSearch);
app.component('InputPassword', InputPassword);
// component - table
app.component('Pagination', Pagination);
app.component('SkeletonLoading', SkeletonLoading);
app.use(stores);
app.use(CKEditor);
app.use(router);
app.use(VueQueryPlugin, vueQueryPluginOptions);
app.use(VueDOMPurifyHTML, {
	default: vuePurifyHTMLConfig,
});
app.mount('#app');
